import React, {useState, useEffect, useContext} from 'react';
import Modal from '@mui/material/Modal';
import Container from '@mui/material/Container';
import { CloseOutlined } from '@mui/icons-material';
import Typography from '@mui/material/Typography';
import useTheme from '@mui/material/styles/useTheme';
import { CircularProgress, Grid, IconButton, Paper } from '@mui/material';
import { DatabaseContext } from '../../firebase/db';
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';

export default function StatsModal({showModal, onClose}) {
    const {getUserStats} = useContext(DatabaseContext); 
    const [stats, setStats] = useState(null);

    useEffect(() => {
        const update = async () => {
            setStats(await getUserStats());
        }
        update();
    }, [showModal]);

    const theme = useTheme();
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '90%',
        maxWidth: 600, 
        minHeight: 200,
        bgcolor: theme.palette.background.paper,
        borderRadius: 5,
        p: 4,
    };

  return (
    <Modal open={showModal} onClose={onClose}>
    <Paper style={style}>
        <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="close"
                sx={{ position: 'absolute', top: "5px", right: "5px"}}
                onClick={onClose}
            >
            <CloseOutlined />
        </IconButton>
        <Container sx={{margin: 1}}>  
            <Typography variant='h6'>Statistics</Typography>
            {stats ? 
            <>
                <Grid container spacing={2}>
                    <Grid item xs={4} alignContent="center" textAlign="center">
                        <Typography variant="subtitle">Current Streak</Typography>
                        <Typography variant="h6" color={theme.palette.success.main}>{stats.streak}</Typography>
                    </Grid>
                    <Grid item xs={4} alignContent="center" textAlign="center">
                        <Typography variant="subtitle">Global Max Hits</Typography>
                        <Typography variant="h6" color={theme.palette.success.main}>{stats.global_max_hits}</Typography>
                    </Grid>
                    <Grid item xs={4} alignContent="center" textAlign="center">
                    <Typography variant="subtitle">Global Max Hits (Hard)</Typography>
                        <Typography variant="h6" color={theme.palette.success.main}>{stats.global_max_hits_hard}</Typography>
                    </Grid>
                </Grid>
                <ResponsiveContainer width="100%" height={300}>
                <LineChart width={500} height={300} data={stats.chart_data} margin={{top: 5, right: 30, left: 20, bottom: 5, }}>
                    <Line type="monotone" dataKey="max_score" stroke={theme.palette.error.light} />
                    <Line type="monotone" dataKey="user_score" stroke={theme.palette.secondary.light} />
                    <Line type="monotone" dataKey="max_score_hard" stroke={theme.palette.error.dark} />
                    <Line type="monotone" dataKey="user_score_hard" stroke={theme.palette.secondary.dark} />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Legend />
                    <Tooltip />
                </LineChart>
                </ResponsiveContainer>
            </>
           : <CircularProgress />
            }
        </Container>
    </Paper>
    </Modal>
  );
}